module.exports = __webpack_public_path__ + "static/media/imenta-placeholder.fe2f060d.svg";